import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const IconCategoryValueGroup = ({ children, className }) => (
  <div className={classNames('icon-category-value-group', className)}>
    {children}
  </div>
);

IconCategoryValueGroup.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node),
  className: PropTypes.object
}

export default IconCategoryValueGroup;
